import { Card, Row, Col, CardTitle } from 'reactstrap';
import { transformNumberCurrency } from '@utils';

const Stats3Component = ({ data, title }) => {
  return (
    <Card body>
      <CardTitle className="m-0">{title}</CardTitle>
      <Row className="d-flex justify-content-between align-items-center">
        {data.map((item) => (
          <Col key={item._id} md={2}>
            <Col
              md={2}
              style={{
                marginBottom: 10
              }}
            >
              {item.icon}
            </Col>
            <Col>
              <div
                style={{
                  color: '#6D6B7B',
                  fontSize: 26,
                  textAlign: 'center',
                  marginBottom: 5
                }}
              >
                {transformNumberCurrency(item.amount, item.style)}
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: 10
                }}
              >
                {item.title}
              </div>
            </Col>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default Stats3Component;
